export default __webpack_public_path__ + "static/media/Upper_Lake_from_Van-Vihar-National-Park.5b12ea67.jpg";